import { DataStoreActionType } from "@castiero/modules/redux/createDataSlice";
import { Waitlist } from "@castiero/web/schemas/Waitlist";
import { ApiServiceDeps } from "./types";

export const access =
  (deps: ApiServiceDeps, actions: DataStoreActionType<Waitlist>) =>
  (id: Waitlist["id"]) =>
    deps.axios
      .post<Waitlist>(`/waitlist/${id}/access`)
      .then(({ data }) => actions.updateItem(data));
